<template>
  <div class="tab-box">
    <div class="tab-list-box">
      <ul class="tab-list">
        <li
          class="tab-li"
          :class="{ 'current-tab': current === item.id }"
          v-for="item in tabList"
          :key="item.id"
          @click="changeTab(item.id)"
        >
          {{ item.title }}
        </li>
      </ul>
      <p class="line"></p>
      <div
        class="record-tab"
        :class="{ 'current-tab': current === 3 }"
        @click="changeTab(3)"
      >
        学习记录
      </div>
    </div>
    <div class="search-box">
      <input
        type="text"
        placeholder="搜索课程名称"
        v-model="keyword"
        class="search-input"
        @keyup.enter="search"
      />
      <i
        v-show="keyword.length > 0"
        class="el-icon-circle-close"
        @click="clear"
      ></i>
      <i class="el-icon-search" @click="search"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebTabBox",
  props: {
    current: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tabList: [
        {
          id: 1,
          title: "推荐",
        },
        {
          id: 2,
          title: "课程广场",
        },
      ],
      currentTab: 2,
      keyword: "",
    };
  },

  mounted() {},

  methods: {
    changeTab(id) {
      this.$emit("update:current", id);
    },
    search() {
      this.$emit("search", this.keyword);
    },
    clear() {
      this.keyword = "";
      this.$emit("search", this.keyword);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // width: 100%;
  min-width: 1080px;
  height: 58px;
  padding: 0 40px;
  margin-bottom: 20px;
  border-radius: 5px;
  background: #fff;
  .tab-list-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .tab-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .tab-li {
        height: 56px;
        padding: 0px 8px;
        margin-right: 20px;
        color: #3a3d4b;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 58px;
        white-space: nowrap;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        &:hover {
          color: #6384f7;
        }
        &.current-tab {
          color: #6384f7;
          border-bottom: 2px solid #6384f7;
        }
      }
    }
    .line {
      width: 1px;
      height: 16px;
      margin: 0 36px 0 16px;
      background: #8895a9;
    }
    .record-tab {
      height: 56px;
      padding: 0px 8px;
      margin-right: 20px;
      color: #3a3d4b;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 58px;
      white-space: nowrap;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      &:hover {
        color: #6384f7;
      }
      &.current-tab {
        color: #6384f7;
        border-bottom: 2px solid #6384f7;
      }
    }
  }
  .search-box {
    position: relative;
    width: 270px;
    height: 34px;
    padding: 0px 20px;
    border-radius: 30px;
    border: 1px solid #e2e2e2;
    .search-input {
      width: 225px;
      height: 34px;
      padding: 0;
      border: 0;
      padding-block: 0;
      padding-inline: 0;
      outline: none;
      &:focus-visible {
        outline: none;
      }
    }
    .el-icon-search {
      position: absolute;
      top: 9px;
      right: 20px;
      font-size: 16px;
      color: #bababa;
      font-weight: 700;
      cursor: pointer;
    }
    .el-icon-circle-close {
      position: absolute;
      top: 9px;
      right: 40px;
      font-size: 16px;
      color: #bababa;
      font-weight: 700;
      cursor: pointer;
    }
  }
}
</style>
